const types = {
	//Get Template name
	GET_INTERNAL_AUDIT_START: "GET_INTERNAL_AUDIT_START",
	GET_INTERNAL_AUDIT_SUCCESS: "GET_INTERNAL_AUDIT_SUCCESS",
	GET_INTERNAL_AUDIT_ERROR: "GET_INTERNAL_AUDIT_ERROR",
	GET_INTERNAL_AUDIT_RESET: "GET_INTERNAL_AUDIT_RESET",

	//Create Template name
	CREATE_INTERNAL_AUDIT_START: "CREATE_INTERNAL_AUDIT_START",
	CREATE_INTERNAL_AUDIT_SUCCESS: "CREATE_INTERNAL_AUDIT_SUCCESS",
	CREATE_INTERNAL_AUDIT_ERROR: "CREATE_INTERNAL_AUDIT_ERROR",
	CREATE_INTERNAL_AUDIT_RESET: "CREATE_INTERNAL_AUDIT_RESET",

	//delete Template name
	DELETE_INTERNAL_AUDIT_START: "DELETE_INTERNAL_AUDIT_START",
	DELETE_INTERNAL_AUDIT_SUCCESS: "DELETE_INTERNAL_AUDIT_SUCCESS",
	DELETE_INTERNAL_AUDIT_ERROR: "DELETE_INTERNAL_AUDIT_ERROR",
	DELETE_INTERNAL_AUDIT_RESET: "DELETE_INTERNAL_AUDIT_RESET",

	//update Template name
	UPDATE_INTERNAL_AUDIT_START: "UPDATE_INTERNAL_AUDIT_START",
	UPDATE_INTERNAL_AUDIT_SUCCESS: "UPDATE_INTERNAL_AUDIT_SUCCESS",
	UPDATE_INTERNAL_AUDIT_ERROR: "UPDATE_INTERNAL_AUDIT_ERROR",
	UPDATE_INTERNAL_AUDIT_RESET: "UPDATE_INTERNAL_AUDIT_RESET",

	//single item  name
	SINGLE_INTERNAL_AUDIT_START: "SINGLE_INTERNAL_AUDIT_START",
	SINGLE_INTERNAL_AUDIT_SUCCESS: "SINGLE_INTERNAL_AUDIT_SUCCESS",
	SINGLE_INTERNAL_AUDIT_ERROR: "SINGLE_INTERNAL_AUDIT_ERROR",
	SINGLE_INTERNAL_AUDIT_RESET: "SINGLE_INTERNAL_AUDIT_RESET",
};

export default types;
